// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__2ED0i","imgContainer":"Card_imgContainer__2YnO5","Text":"Card_Text__3U0XV","buttons":"Card_buttons__2VD09"};